// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1wV6I","imageUploader":"EGiftCard_imageUploader__2DYOQ"};